import { useState } from 'react';
import type { SyntheticEvent } from 'react';

import { Mimes } from '/constants/file';

import type { IPreviewComponentProps } from '../../types';
import { PlayButtonStyled } from '../styles';

import { ContainerStyled, IFrameStyled } from './styles';

export function HTMLPreview({
  url,
  autoPlay,
  onRebuildThumbnail: _,
  onClick,
  Fallback: _Fallback,
  ...rest
}: IPreviewComponentProps) {
  const [activeFrame, setActiveFrame] = useState(Boolean(autoPlay));

  const handleClick = (event: SyntheticEvent) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (onClick) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      onClick(event);
      return;
    }

    setActiveFrame(true);
  };

  return (
    <ContainerStyled $fillDialog={Boolean(autoPlay)} onClick={handleClick}>
      {!activeFrame ? (
        <PlayButtonStyled />
      ) : (
        <IFrameStyled {...rest} src={url} title='url' sandbox='allow-scripts' loading={undefined} />
      )}
    </ContainerStyled>
  );
}

HTMLPreview.mimes = Mimes.HTML;
